<template>
  <v-container>
		<v-app-bar dense dark app color="secondary">
			<v-toolbar-title> Administrar </v-toolbar-title>
		</v-app-bar>
    <v-row>
      <v-col cols="12">
        <v-card
          color="primary"
					dark
          block
          @click="() => $router.push({ name: 'novo-irmao' })"
        >
					<v-card-title class="justify-center">
						<v-icon left>mdi-account</v-icon>
						Novo Irmão
					</v-card-title>
        </v-card>
      </v-col>
      <v-col v-if="éSecretarioDeInformatica" cols="12">
        <v-card
          color="primary"
					dark
          block
          @click="() => $router.push({ name: 'novo-visitante' })"
        >
					<v-card-title class="justify-center">
						<v-icon left>mdi-account-plus</v-icon>
						Novo Visitante
					</v-card-title>
        </v-card>
      </v-col>
			<ComponentAuthGuard :requires="['admin']">
				<v-col cols="12">
					<v-card
						color="primary"
						dark
						block
						@click="() => $router.push({ name: 'nova-loja' })"
					>
						<v-card-title class="justify-center">
							<v-icon left>mdi-bank</v-icon>
							Nova Loja
						</v-card-title>
					</v-card>
				</v-col>
				<v-col cols="12">
					<v-card
						color="primary"
						dark
						block
						@click="() => $router.push({ name: 'nova-potencia' })"
					>
						<v-card-title class="justify-center">
							<v-icon left>mdi-web</v-icon>
							Nova Potência
						</v-card-title>
					</v-card>
				</v-col>
			</ComponentAuthGuard>
      <!-- <v-col cols="12">
        <v-card
          color="primary"
					dark
          block
        >
					<v-card-title class="justify-center">
						<v-icon left>mdi-math-compass</v-icon>
						Novo Somar
					</v-card-title>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import { userModule } from '@/store'

const éSecretarioDeInformatica = computed(() => {
	const { currentUser } = userModule
	return !!currentUser && currentUser.role !== 'Visitante' && currentUser.secretarioDeInformatica
})
</script>
